/* @flow */
import { Box } from '@sonyged/proc-ui';
import styled from 'styled-components';

import Mise01Img from '../../../assets/images/pages/sushi/simulation/sushi_ﬁ_mise01@3x.png';
import Mise02Img from '../../../assets/images/pages/sushi/simulation/sushi_ﬁ_mise02@3x.png';
import Mise03Img from '../../../assets/images/pages/sushi/simulation/sushi_ﬁ_mise03@3x.png';
import MiseRepeatImg from '../../../assets/images/pages/sushi/simulation/sushi_field_sim-bg-repeat.png';

const Bg = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'auto 100%',
  border: 'none',
});

export const Mise01 = styled(Bg)({
  backgroundImage: `url('${Mise01Img}')`,
});

export const Mise02 = styled(Bg)({
  backgroundImage: `url('${Mise02Img}')`,
});

export const Mise03 = styled(Bg)({
  backgroundImage: `url('${Mise03Img}')`,
});

export const MiseRepeat = styled(Bg)({
  backgroundImage: `url('${MiseRepeatImg}')`,
  backgroundRepeat: 'repeat-x',
});
